import { AnalyticsService } from "@/services/analytics";
import type { AnalyticsClientEvent } from "@appfire/fuse-analytics-client/dist/src/types/analytics.types";

export function createAnalyticsServiceMock() {
  return new LoggingAnalyticsService();
}

export class LoggingAnalyticsService extends AnalyticsService {
  protected sendEvent(event: AnalyticsClientEvent) {
    console.debug("analytics event:", event);
    return Promise.resolve();
  }
}
